import Button from '@components/buttons/button/button.component'
import Loader from '@components/loader/loader.component'
import Modal from '@components/modals/modal/modal.component'
import ToastHelper from '@helpers/toast.helper'
import LogService from '@services/log/log.service'
import SheHulkService from '@services/shehulk/shehulk.service'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './modal-contract.component.scoped.scss'
import './modal-contract.component.scss'

interface ModalContractProps {
  configId?: string
  open?: boolean
  className?: string
  onCloseChange?: () => any | void
  onAcceptedChange?: () => any | void
}

export default ({ className = '', open = false, configId = 'hub', onCloseChange, onAcceptedChange }: ModalContractProps) => {
  const [loading, setLoading] = useState(false)
  const sheHulkService = useMemo(() => new SheHulkService(), [])
  const logService = useMemo(() => new LogService(), [])
  const [contract, setContract] = useState('')
  const [t, i18n] = useTranslation('modalContract')
  logService.init('Modal Contract Component')
  const toast = new ToastHelper().toast

  const onClose = useCallback(() => {
    if (onCloseChange && typeof onCloseChange === 'function' && open) {
      onCloseChange()
    }
  }, [onCloseChange, open])

  const contractMethod = useCallback(async () => {
    try {
      const res = await sheHulkService.getPublicContract('plataform', configId, i18n?.language)
      if (res?.contract) {
        setContract(res?.contract)
        setLoading(false)
      } else {
        setLoading(false)
        throw new Error('Error on get contract')
      }
    } catch (error) {
      setLoading(false)
      onClose()
      logService.error({
        message: 'Error on get contract',
        error,
      })
      toast.error(t('unexpected'), {
        closeButton: true,
        className: 'full text-bold',
        position: `${window.innerWidth > 991 ? 'top' : 'bottom'} center`,
        duration: 3600000,
        notOverClick: true,
        immediately: true,
      })
    }
  }, [i18n, configId, sheHulkService, onClose, t, logService, toast])

  useEffect(() => {
    if (open && !loading) {
      setLoading(true)
      contractMethod()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, contractMethod])

  const parseContract = (contract) => {
    return (contract = contract.replace(/<style\b[^<>]*>[\s\S]*?<\/style\s*>/gi, ''))
  }

  const onAccepted = () => {
    if (onAcceptedChange && typeof onAcceptedChange === 'function' && open) {
      onAcceptedChange()
    }
  }

  return (
    <Modal
      className={className}
      open={open}
      onCloseChange={() => onClose()}
      header={
        <h6 className="m-0">
          {t('title')} {t('subtitle')}
        </h6>
      }
      footer={
        loading ? null : (
          <div className="buttons">
            <Button
              onClick={() => onClose()}
              id="refuse-contract-button"
              color="var(--background_secondary)"
              invertedHover
              textColor="var(--text_color)"
              borderColor="var(--text_color)"
            >
              {t('refuse')}
            </Button>
            <Button onClick={() => onAccepted()} id="accepted-contract-button">
              {t('accepted')}
            </Button>
          </div>
        )
      }
      modalSize="lg"
    >
      {loading ? (
        <Loader size="big" />
      ) : (
        <>
          <div className="content-contract-modal contract-styled scrollbar" dangerouslySetInnerHTML={{ __html: parseContract(contract) }} />
        </>
      )}
    </Modal>
  )
}
